/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListKeyWordAction } from '../models/api-response-list-key-word-action';
import { createOrUpdateListOfKeyWordAction } from '../fn/key-word-action-api/create-or-update-list-of-key-word-action';
import { CreateOrUpdateListOfKeyWordAction$Params } from '../fn/key-word-action-api/create-or-update-list-of-key-word-action';
import { listKeyWordAction } from '../fn/key-word-action-api/list-key-word-action';
import { ListKeyWordAction$Params } from '../fn/key-word-action-api/list-key-word-action';

@Injectable({ providedIn: 'root' })
export class KeyWordActionApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createOrUpdateListOfKeyWordAction()` */
  static readonly CreateOrUpdateListOfKeyWordActionPath = '/v1/api/ui/key-word-action/create-update-list/{refPhoneCompany}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateListOfKeyWordAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateListOfKeyWordAction$Response(params: CreateOrUpdateListOfKeyWordAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListKeyWordAction>> {
    return createOrUpdateListOfKeyWordAction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateListOfKeyWordAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateListOfKeyWordAction(params: CreateOrUpdateListOfKeyWordAction$Params, context?: HttpContext): Observable<ApiResponseListKeyWordAction> {
    return this.createOrUpdateListOfKeyWordAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListKeyWordAction>): ApiResponseListKeyWordAction => r.body)
    );
  }

  /** Path part for operation `listKeyWordAction()` */
  static readonly ListKeyWordActionPath = '/v1/api/ui/key-word-action/list/{refPhoneCompany}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listKeyWordAction()` instead.
   *
   * This method doesn't expect any request body.
   */
  listKeyWordAction$Response(params: ListKeyWordAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListKeyWordAction>> {
    return listKeyWordAction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listKeyWordAction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listKeyWordAction(params: ListKeyWordAction$Params, context?: HttpContext): Observable<ApiResponseListKeyWordAction> {
    return this.listKeyWordAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListKeyWordAction>): ApiResponseListKeyWordAction => r.body)
    );
  }

}
